var map = {
	"./basketball-active.webp": 1477,
	"./basketball.webp": 1478,
	"./bg.webp": 1479,
	"./football-active.webp": 1480,
	"./football.webp": 1481,
	"./games-active.webp": 1482,
	"./games.webp": 1483,
	"./information.webp": 1484,
	"./live-streaming-cover.webp": 1485,
	"./lv-active-bg.webp": 1486,
	"./video-bg.webp": 1487,
	"./video-icon.webp": 1488,
	"./vs.webp": 1489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;